import Mentions from './Mentions';
export default Mentions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-mentions/es/index.js
// module id = 973
// module chunks = 0